import Text from '#components/a/Text'
import i18n from 'i18next'
import React from 'react'
export const azubiStatus = {
  good: 'good',
  warning: 'warning',
  critical: 'critical',
}

class AzubiStatusBadge extends React.Component {
  render() {
    const {status, numberOfMissingNachweise} = this.props
    return (
      <div className="row-min">
        <div className={'azubiBadgeDotContainer'}>
          <div className={'azubiBadgeDot azubiBadgeDot--' + status}></div>
        </div>
        <Text
          text={
            numberOfMissingNachweise === 1
              ? i18n.t('number_of_nachweis_missing_one', [1])
              : i18n.t('number_of_nachweis_missing_plural', [numberOfMissingNachweise])
          }
          modifier="small-no-padding"
        />
      </div>
    )
  }
}

export default AzubiStatusBadge
